import { CalendarProvider } from '../../provider';
import type { UseCalendarReturn } from '../../provider';
import { noOutline } from '../common-styles';
import { DialogCalendarDisplay } from './dialog-calendar-display';

export const DialogCalendarLayout = (props: Omit<UseCalendarReturn, 'children'>) => (
  <CalendarProvider {...props} className={noOutline}>
    <DialogCalendarDisplay />
  </CalendarProvider>
);
